import React from "react";
import {useParams, NavLink} from "react-router";
import {ArrowBackIos} from "@mui/icons-material";
import {Button, Paper, Stack, Box, Typography} from "@mui/material";
import PriceName from "../../components/price/PriceDetail/PriceName.tsx";
import {useLocationFormState} from "../../components/price/PriceForm/PriceUpdateForm";
import PriceUpdateFormProvider from "../../components/price/PriceForm/PriceUpdateFormProvider";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const PriceUpdateEditPage = () => {
    
    useTitle(t`Update Price`);

    const { priceId: id } = useParams();
    
    return (
        <Box data-testid="Price-update-form">
            <Paper sx={ { padding: "2em" } }>
                <Stack direction="column" spacing={1}>
                    <Typography
                        sx={ { flex: '1 1 100%' } }
                        variant="h6"
                        component="div"
                        data-testid="Price-update-title"
                    >
                        <Trans>Edit Price</Trans>:  <PriceName id={id}/>
                    </Typography>
                    <PriceUpdateFormProvider
                        id={id}
                        cancelButton={
                            <Button size="medium" variant="contained" color="inherit" startIcon={<ArrowBackIos />}
                                    component={NavLink}
                                    to=".."
                                    relative="path"
                                    viewTransition={true}
                            >
                                <Trans>Cancel</Trans>
                            </Button>
                        }
                        initialFormState={useLocationFormState}
                    />
                </Stack>
            </Paper>
        </Box>
    )
}

export default PriceUpdateEditPage;
